<h2 mat-dialog-title>Edit menu</h2>

<form [formGroup]="form">
  <div mat-dialog-content>
    <mat-form-field appearance="outline" style="width: 100%">
      <mat-label>Menu name</mat-label>
      <input matInput formControlName="name" />
      <mat-error *ngIf="form.get('name')?.invalid && form.get('name')?.touched">
        Menu name is required
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" style="width: 100%">
      <mat-label>Description</mat-label>
      <textarea matInput rows="3" formControlName="description"></textarea>
    </mat-form-field>
  </div>

  <div mat-dialog-actions align="end">
    <button mat-button type="button" (click)="cancel()">Cancel</button>
    <button
      mat-flat-button
      color="primary"
      type="button"
      (click)="save()"
      [disabled]="form.invalid"
    >
      Save changes
    </button>
  </div>
</form>
